import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function InstructorSection() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { t, i18n } = useTranslation("global");
  const [instructors, setInstructors] = useState([]);

  useEffect(() => {
    const fetchInstructors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/instructors`, {
          headers: {
            "Accept-Language": i18n.language, // استخدم اللغة من i18n
          },
        });
        

        const data = await response.json(); // 👈 مهم تفك الـ JSON كده
        setInstructors(data.data); // 👈 بعد ما تفكه توصل للـ data
      } catch (error) {
        console.error("Error fetching instructors:", error);
      }
    };

    const lang = i18n.language || "en"; // استخدم اللغة من i18n
    fetchInstructors(lang);
  }, [i18n.lan]);


  return (
    <section className="container my-5">
      <div>
        <h1 className="main-color our-instructors-title">
          {t("ourInstructors.title")}
        </h1>
        <div className="d-flex flex-wrap justify-content-between gap-2">
          <p className="paragraph-color">{t("ourInstructors.description")}</p>
          <Link to="/Instructors" className="mb-3">
            <span className="second-color">
              {" "}
              {t("ourInstructors.view")}{" "}
              {localStorage.getItem("lang") === `"ar"` ? (
                <i className="bi bi-arrow-left"></i>
              ) : (
                <i className="bi bi-arrow-right"></i>
              )}
            </span>
          </Link>
        </div>
      </div>

      <div className="position-relative">
        <div
          ref={prevRef}
          className="custom-prev-arrow"
          style={{
            position: "absolute",
            top: "50%",
            left: "-30px",
            zIndex: 10,
            cursor: "pointer",
            width: "40px",
            height: "40px",
            backgroundColor: "#f0f0f0",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i className="bi bi-chevron-left" style={{ fontSize: "20px" }}></i>
        </div>
        <div
          ref={nextRef}
          className="custom-next-arrow"
          style={{
            position: "absolute",
            top: "50%",
            right: "-30px",
            zIndex: 10,
            cursor: "pointer",
            width: "40px",
            height: "40px",
            backgroundColor: "#f0f0f0",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i className="bi bi-chevron-right" style={{ fontSize: "20px" }}></i>
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          spaceBetween={20}
          slidesPerView={3}
          breakpoints={{
            1200: { slidesPerView: 4 },
            992: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
          className="mySwiper"
        >
          {instructors.map((instructor) => (
            <SwiperSlide key={instructor.id}>
              <Link to={'/instructortDetails/' + instructor.id}> 
               <div className="card p-3">
                <img
                  src={instructor.image || "assets/imgs/teacger-1.jpg.svg"}
                  className="card-img-top img-instructor"
                  alt={instructor.name}
                />
                <div className="card-body">
                  <h5 className="card-title fw-bold main-color text-center">
                    {instructor.name}
                  </h5>
                  <p className="card-text paragraph-color text-center">
                    {instructor.position}
                  </p>
                </div>
              </div></Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default InstructorSection;
